import { useActionConfirm } from './useActionConfirm';

export const TITLE_DEACTIVATING = 'Deactivating System';
export const TITLE_ACTIVATING = 'Activating System Now';

/**
 * Action hook for the activate/deactivate flow and is called specifically
 * by the Dashboard ACTIVATE/DEACTIVATE buttons. Dispatches the appropriate
 * command on confirmation based on the isActive flag from SystemContext.
 * @param {{ isActive: boolean, initiateActivation: Function, stopActivation: Function, showToast: Function }} deps
 * @returns {import('./useActionConfirm').ActionHook}
 */
export function useActivateAction({ isActive, initiateActivation, stopActivation, showToast }) {
  const getTitle = () => isActive ? TITLE_DEACTIVATING : TITLE_ACTIVATING;
  const onConfirm = () => isActive ? stopActivation() : initiateActivation();
  return useActionConfirm(getTitle, onConfirm, showToast);
}
